// @flow
import 'react-fastclick'
import * as React from 'react'
import { camelizeKeys } from 'humps'
import URI from 'urijs'
import { render } from 'react-dom'
import HomePage from 'pages/home'

window.lego = camelizeKeys(window.lego || {}, (key, convert, options) => {
  return /^[A-Z0-9_]+$/.test(key) ? key : convert(key, options)
})

const uri = new URI(window.location.href)
const query = URI.parseQuery(uri.query())

// homepage schools and events lists
const target = document.querySelector('#REACT_PAGE_TARGET')

if (target) {
  render(<HomePage showCloseAlertForSchoolName={query.school_closed} />, target)
}
